import client from "./client";

const endpoint = "vfs/apply";

const vfsApply = ({ body }) => client.post(endpoint, body);

export { vfsApply };
